import { getUrl } from 'aws-amplify/storage';

const man = "public/siteassets/man.jpg"
const woman = "public/siteassets/woman.jpg"
const other = "public/siteassets/generic-profile-icon-8.jpg";


export default async (key, sex = null) => {
    let path = null;

    if (key) {
        // Handle legacy keys from Gen 1 which might lack the 'public/' prefix in the DB
        // but exist in the 'public/' folder in S3.
        const hasPrefix = key.startsWith('public/') || key.startsWith('protected/') || key.startsWith('private/') || key.startsWith('media/') || key.startsWith('profile-pictures/');
        path = hasPrefix ? key : `public/${key}`;
    } else if (sex) {
        if (sex === "MALE") path = man;
        if (sex === "FEMALE") path = woman;
    }

    if (!path) path = other;

    try {
        const urlResult = await getUrl({ path });
        return urlResult.url.toString();
    } catch (error) {
        console.warn(`Failed to get URL for path: ${path}`, error);
        // Fallback or retry logic could go here, but for now return other image if primary fails
        if (path !== other) {
            try {
                return (await getUrl({ path: other })).url.toString();
            } catch (e) {
                return ""; // Absolute failure
            }
        }
        return "";
    }
}